import { Button} from "@sgi/gravity/Button";
import { FAIcon} from "@sgi/gravity/FAIcon";
import { Typography } from "@sgi/gravity/Typography";
import { Box, Flex } from "@chakra-ui/react";
import { faPhone } from "@fortawesome/pro-solid-svg-icons";
import { useWrapper } from "../Context/WrapperContext";
import Title from "../Common/Title";
import useFocusControl from "../Custom Hooks/useFocusControl";
export default function CustomerService() {
  const { decrement } = useWrapper();
  
  const ref = useFocusControl(index => index === 1);
  return (
    <Flex
    ref={ref}
      direction="column"
      maxW={544}
      padding={38}
      mx="auto"
      data-testid="customerservice-test"
    >
      <Title text="Customer service" />
      <Box
        style={{ zIndex: "200", position: "relative", paddingTop: "10px" }}
        data-testid="customerservice-inside-test"
      >
        <Typography variant="body" mb={8} data-testid="if-you-need-help-test">
          If you need help with your MySGI account, please contact us
        </Typography>
        <Flex
          flexDirection="row"
          style={{ paddingBottom: "20px" }}
          data-testid="phone-number-test"
        >
          <FAIcon icon={faPhone} style={{ paddingRight: "20px" }} size="3xl" />
          1-844-TLK-2SGI (1-844-855-2744)
        </Flex>
        <Typography
          variant="body"
          mb={8}
          data-testid="if-you-have-questions-test"
        >
          If you have questions about your policy, please contact your broker.
        </Typography>
        <Button
          my={1}
          isFullWidth
          data-testid="back-button-test"
          onClick={decrement}
        >
          Back to Sign In
        </Button>
      </Box>
    </Flex>
  );
}
